import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ClientProvider } from "@/contexts/ClientContext";
import { ToastProvider } from "@/components/Toast";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider as AuthContextProvider } from "@/contexts/AuthContext";
import { AuthProvider } from "@/components/AuthProvider";
import { Toaster } from "@/components/ui/toaster";
import { queryClient } from "@/lib/queryClient";
import { AppearanceProvider } from "@/components/CommonFeatures/Appearance";

interface AppProvidersProps {
  children: React.ReactNode;
}

const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <AppearanceProvider storageKey="shiftleft-appearance">
      <ThemeProvider>
        <ClientProvider>
          <ToastProvider>
            <TooltipProvider>
              <AuthContextProvider>
                <AuthProvider>
                  <Toaster />
                  {children}
                </AuthProvider>
              </AuthContextProvider>
            </TooltipProvider>
          </ToastProvider>
        </ClientProvider>
      </ThemeProvider>
    </AppearanceProvider>
  </QueryClientProvider>
);

export default AppProviders;

